import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bike } from "lucide-react";
import { supabase, rpc } from "@/lib/supabase";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Card, Loader } from "@/components/kit";

const field =
  "w-full rounded-xl border border-[#27272A] bg-[#0d0d0f] px-3.5 py-2.5 text-sm text-white placeholder-gray-500 outline-none focus:border-[#FF6A00]";
const labelCls = "mb-1.5 block text-xs font-bold uppercase tracking-wider text-gray-400";

export default function DriverVehicle() {
  const { user } = useAuth();
  const [loaded, setLoaded] = useState(false);
  const [f, setF] = useState({ plate: "", brand: "", model: "", color: "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  useEffect(() => {
    supabase
      .from("vehicles")
      .select("*")
      .eq("driver_id", user.id)
      .maybeSingle()
      .then(({ data }) => {
        if (data) setF({ plate: data.plate || "", brand: data.brand || "", model: data.model || "", color: data.color || "" });
        setLoaded(true);
      });
  }, [user.id]);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await rpc("upsert_my_vehicle", { p_type: "MOTORCYCLE", p_plate: f.plate, p_brand: f.brand, p_model: f.model, p_color: f.color });
      toast.success("Vehículo actualizado");
    } catch (err) {
      toast.error(err?.message || "No se pudo guardar");
    } finally {
      setSaving(false);
    }
  };

  if (!loaded) return <Loader />;
  return (
    <div>
      <PageHeader title="Mi vehículo" subtitle="En esta versión solo se admite motocicleta." testId="driver-vehicle" />
      <div className="max-w-xl">
        <Card>
          <div className="mb-5 flex items-center gap-3 rounded-xl border border-[#FF6A00]/40 bg-[#FF6A00]/10 px-4 py-3">
            <Bike size={20} className="text-[#FF6A00]" />
            <span className="font-heading font-bold text-white">Motocicleta</span>
          </div>
          <form onSubmit={save} className="grid gap-4 sm:grid-cols-2">
            <div>
              <label className={labelCls}>Placa</label>
              <input className={field} value={f.plate} onChange={set("plate")} placeholder="ABC12D" data-testid="vehicle-plate" />
            </div>
            <div>
              <label className={labelCls}>Color</label>
              <input className={field} value={f.color} onChange={set("color")} placeholder="Negro" data-testid="vehicle-color" />
            </div>
            <div>
              <label className={labelCls}>Marca</label>
              <input className={field} value={f.brand} onChange={set("brand")} placeholder="Yamaha" data-testid="vehicle-brand" />
            </div>
            <div>
              <label className={labelCls}>Modelo</label>
              <input className={field} value={f.model} onChange={set("model")} placeholder="NMAX" data-testid="vehicle-model" />
            </div>
            <div className="sm:col-span-2">
              <button
                type="submit"
                disabled={saving}
                data-testid="vehicle-save"
                className="rounded-xl bg-[#FF6A00] px-6 py-3 font-extrabold text-black transition-transform active:scale-95 disabled:opacity-60"
              >
                {saving ? "Guardando…" : "Guardar vehículo"}
              </button>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
}
